import React from 'react';

const QuickActionCard = ({ icon, title, subtitle, color, onClick, isDark = false }) => {
  return (
    <div
      className="quick-action-card"
      onClick={onClick}
      style={{
        cursor: 'pointer',
        padding: '18px 16px',
        backgroundColor: isDark ? '#161b22' : '#fff',
        borderRadius: '12px',
        boxShadow: isDark ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.06)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        border: isDark ? '1px solid #30363d' : '1px solid #e8e8e8',
        minWidth: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = isDark ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = isDark ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.06)';
      }}
    >
      <div
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '10px',
          backgroundColor: color || '#1890ff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '22px',
        }}
      >
        {icon}
      </div>
      <div>
        <h3
          style={{
            margin: 0,
            fontSize: '15px',
            fontWeight: '600',
            color: isDark ? '#e6edf3' : '#1a1a1a',
            marginBottom: '2px',
          }}
        >
          {title}
        </h3>
        <p
          style={{
            margin: 0,
            fontSize: '13px',
            color: isDark ? '#8b949e' : '#8c8c8c',
            lineHeight: '1.4',
          }}
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default QuickActionCard;